// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container___2UUON","input":"styles__input___2erGl","containerOpen":"styles__containerOpen___1Kiqv","suggestionsContainer":"styles__suggestionsContainer___1rfuS","suggestionsList":"styles__suggestionsList___1pFtL","suggestion":"styles__suggestion___1KUZj","suggestionFocused":"styles__suggestionFocused___2PU7u","sectionTitle":"styles__sectionTitle___rjlLN","rotate":"styles__rotate___38suE","fadein":"styles__fadein___15ZsD","slideFromRight":"styles__slideFromRight___DqaTz","waves":"styles__waves___32mhh"};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/ExpertiseSearchBar/styles.scss
// module id = ./resources/assets/js/components/ExpertiseSearchBar/styles.scss
// module chunks = 0